document.addEventListener('DOMContentLoaded', function() {
      function getOS() {
        var uA = navigator.userAgent || navigator.vendor || window.opera;
        if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';
        var i, os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
        for (i = 0; i < os.length; i++) if (new RegExp(os[i],'i').test(uA)) return os[i];
      }
      var getOSPhone = getOS();
      if(getOS() === 'iOS'){
              appLink = "https://apps.apple.com/us/app/id1661765661"; // Replace with your Play Store link
              $('.install-app-btn-play').hide();
             $('.install-app-btn-apple').show();
          } else if (getOS() === 'Android') {
              appLink = "https://play.google.com/store/apps/details?id=com.deodap.gallery"; // Replace with your App Store link
             $('.install-app-btn-play').show();
             $('.install-app-btn-apple').hide();
          } else {
              return; // Do nothing if it's not Android or iOS
          }
      // Show the popup after 30 seconds
      setTimeout(function() {
          var appLink;
          var installButton = document.getElementById('install-app-button');
          document.getElementById('app-install-popup').style.display = 'block';
          document.body.classList.add('popup-open'); // Add class to body when popup is shown
          document.body.classList.add('popup-scroll'); // Add popup-scroll class to body when popup is shown
      }, 10);

      // Function to close the popup
      function closePopup() {
          document.getElementById('app-install-popup').style.display = 'none';
          document.body.classList.remove('popup-open'); // Remove class from body when popup is closed
          document.body.classList.remove('popup-scroll'); // Remove popup-scroll class from body when popup is closed
      }
      document.getElementById('close-popup').addEventListener('click', closePopup);
      document.getElementById('install-app-button').addEventListener('click', closePopup);
      document.getElementById('close-popup-svg').addEventListener('click', closePopup);
  });